import { LinkProps as NextLinkProps } from 'next/link';
import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import styles from './link.module.css';
import { useBottomNavigation } from '../../bottom-navigation.context';
import { Icon, type IconType } from '../icon';

export type LinkProps = PropsWithChildren<NextLinkProps | ButtonHTMLAttributes<HTMLButtonElement>> & {
  icon: IconType;
  isActive?: boolean;
};
export const Link = ({ children, icon, isActive, ...props }: LinkProps) => {
  const dataActive = Boolean(isActive).toString();
  const { linkFactory } = useBottomNavigation();

  if ('href' in props) {
    return linkFactory({
      ...props,
      className: styles.link,
      'data-active': dataActive,
      children: (
        <>
          <span className={styles.icon}>
            <Icon icon={icon} isActive={!!isActive} />
          </span>
          {children}
        </>
      ),
    });
  }

  return (
    <button {...props} className={styles.link} data-active={dataActive}>
      <span className={styles.icon}>
        <Icon icon={icon} isActive={!!isActive} />
      </span>
      {children}
    </button>
  );
};
